export default __webpack_public_path__ + "static/media/AquaShine.abcf426f.png";